import * as Sentry from "@sentry/browser";

export const sentryErrorSend = (request: any, error: any) => {
  Sentry.withScope((scope: any) => {
    scope.setExtra("error", { request, error: error.response });
    Sentry.captureException(new Error("Bad Request"));
  });
};
